import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Alert from '../components/Alert';
import app from '../app';

/**
 * Returned by `AlertManagerState.show`. Used to dismiss alerts.
 */

export default class AlertManagerState {
  constructor() {
    _defineProperty(this, "activeAlerts", {});
    _defineProperty(this, "alertId", 0);
    _defineProperty(this, "loadingPool", 0);
  }
  getActiveAlerts() {
    return this.activeAlerts;
  }

  /**
   * Show an Alert in the alerts area.
   *
   * @return The alert's ID, which can be used to dismiss the alert.
   */

  show(arg1, arg2, arg3) {
    // Assigns variables as per the above signatures
    let componentClass = Alert;
    let attrs = {};
    let children;
    if (arguments.length == 1) {
      children = arg1;
    } else if (arguments.length == 2) {
      attrs = arg1;
      children = arg2;
    } else if (arguments.length == 3) {
      componentClass = arg1;
      attrs = arg2;
      children = arg3;
    }
    this.activeAlerts[++this.alertId] = {
      children,
      attrs,
      componentClass
    };
    m.redraw();
    return this.alertId;
  }

  /**
   * Dismiss an alert.
   */
  dismiss(key) {
    if (!key || !(key in this.activeAlerts)) return;
    delete this.activeAlerts[key];
    m.redraw();
  }

  /**
   * Clear all alerts.
   */
  clear() {
    this.activeAlerts = {};
    m.redraw();
  }

  /**
   * Shows a loading alert.
   */
  showLoading() {
    this.loadingPool++;
    if (this.loadingPool > 1) return null;
    return this.show({
      type: 'warning',
      dismissible: false
    }, app.translator.trans('core.lib.loading_indicator.accessible_label'));
  }

  /**
   * Hides a loading alert.
   */
  clearLoading() {
    this.loadingPool--;
    if (this.loadingPool === 0) this.clear();
  }
}
flarum.reg.add('core', 'common/states/AlertManagerState', AlertManagerState);